import { COMPANY_CODES_LOADED } from '../actions/types';

const initialState = {
  loadingCompanyCodes: true,
  companyCodes: []
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case COMPANY_CODES_LOADED:
      return {
        ...state,
        loadingCompanyCodes: false,
        companyCodes: [...payload]
      };
    default:
      return state;
  }
};
